import { api } from '@/lib/api';
import type {
  CalibrationProceduresListResponse,
  CalibrationProcedureFilters,
  CalibrationProcedure,
  CreateCalibrationProcedureInput,
  UpdateCalibrationProcedureInput,
} from './types';

// =============================================================================
// API Functions
// =============================================================================

/**
 * Get calibration procedures with filtering, pagination, and sorting.
 */
export async function getCalibrationProcedures(
  filters: CalibrationProcedureFilters = {},
): Promise<CalibrationProceduresListResponse> {
  return api.get<CalibrationProceduresListResponse>('/v4/calibration-procedures', {
    search: filters.search || undefined,
    deleted: filters.deleted,
    pageNumber: filters.page ?? 0,
    pageLength: filters.pageLength ?? 25,
    sortKey: filters.sortKey,
    sortDirection: filters.sortDirection,
  });
}

/**
 * Get a single calibration procedure by ID
 */
export async function getCalibrationProcedure(id: string): Promise<CalibrationProcedure> {
  return api.get<CalibrationProcedure>(`/v4/calibration-procedures/${id}`);
}

/**
 * Create a new calibration procedure (via V3 MongoDB API)
 */
export async function createCalibrationProcedure(
  data: CreateCalibrationProcedureInput,
): Promise<{ calibrationprocedure: { _id: string } }> {
  return api.post('/v4/calibrationprocedures/', data);
}

/**
 * Update an existing calibration procedure (via V3 MongoDB API)
 */
export async function updateCalibrationProcedure(
  id: string,
  data: UpdateCalibrationProcedureInput,
): Promise<unknown> {
  return api.put(`/v4/calibrationprocedures/${id}`, data);
}

/**
 * Delete a calibration procedure (via V3 MongoDB API)
 */
export async function deleteCalibrationProcedure(id: string): Promise<unknown> {
  return api.delete(`/v4/calibrationprocedures/${id}`);
}
